"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainOutcomeProbability = getMainOutcomeProbability;
const types_1 = require("../../containers/CommonDataProvider/types");
/*
 */
function getMainOutcomeProbability({ probs, mainOutcomeTypes, mainOutcomeType, }) {
    if (!mainOutcomeType || !mainOutcomeTypes || !probs) {
        return undefined;
    }
    return probs[`${mainOutcomeTypes[types_1.MainOutcomeTypes[mainOutcomeType]]}`];
}
//# sourceMappingURL=getMainOutcomeProbability.js.map